<template>
    <div v-if="producto_almacen">
        <Box  @close="cerrar()">
            <template #top>Kardex</template>
            <template #center>
                <div class="nj-cols">
                    <div class="nj-card">
                        <div class="nj-subtitle-1">Datos generales</div>
                        <br>
                        <div class="nj-cols c3">
                            <LabelGroup label="Insumo" :value="producto_almacen.prv_nombre"></LabelGroup>
                            <LabelGroup label="Saldo inicial" :value="producto_almacen.pdd_saldo_inicial"></LabelGroup>
                            <LabelGroup label="Saldo final" :value="producto_almacen.pal_stock"></LabelGroup>
                        </div>
                        <!-- datos generales del del producto -->
                    </div>
                    <div class="nj-card">
                        <div class="nj-subtitle-1">Historial</div>
                        <br>
                        <b-table :data="producto_almacen.page_result.list" @page-change="changePage($event)" :total="page.total" :per-page="page.size" :current-page="page.number" pagination-position="bottom" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page" :pagination-simple="true" :pagination-rounded="true"
                            :paginated="true" :backend-pagination="true">
                            <template slot-scope="props">
                                <b-table-column label="Glosa" header-class="is-info">{{ props.row.kdx_glosa }}</b-table-column>
                                <b-table-column label="Fecha" header-class="is-info">{{ props.row.kdx_fecha }}</b-table-column>
                                <b-table-column label="Cantidad (insumo)" header-class="is-info" :class="getColor(props.row.kdx_cantidad)">{{ getCantidad(props.row.kdx_cantidad) }}</b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </template>
        </Box>
    </div>
</template>
<script>
import { ProductoAlmacenService, ResponseStatus } from "../../rest"
import Toast from "../../util/toast"
import { Box } from "../components"
import LabelGroup from "../components/LabelGroup.vue"
export default {
    name: "ProductoAlmacenKardex",
    components: {
        Box,
        LabelGroup,
    },
    props: {
        pal_id: {
            type: Number
        }
    },
    data() {
        return {
            producto_almacen: null,
            page: {
                number: 1,
                size: 10,
                total: 0
            },
        }
    },
    methods: {
        buscar() {
            const request = {
                producto_almacen: {
                    pal_id: this.pal_id,
                    page: this.page
                }
            }
            ProductoAlmacenService
                .obtenerKardex(request)
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.producto_almacen = response.data
                        this.page = this.producto_almacen.page_result.page
                    }
                    else {
                        Toast.warn(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        changePage(number) {
            this.page.number = number
            this.buscar()
        },
        getColor(value) {
            return value < 0 ? "red" : "blue"
        },
        getCantidad(cantidad) {
            return cantidad > 0
                ? `+${cantidad}`
                : cantidad
        },
        cerrar() {
            this.$emit("close")
        }
    },
    mounted() {
        this.buscar()
    }
}
</script>

<style scoped>
.red {
    color: var(--red);
}

.blue {
    color: var(--blue);
}
</style>